import { render, staticRenderFns } from "./PackHistory.vue?vue&type=template&id=773ff921&scoped=true"
import script from "./PackHistory.vue?vue&type=script&lang=js"
export * from "./PackHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ff921",
  null
  
)

export default component.exports